import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    fontSize: '1rem',
    width: '60%',
    margin: theme.spacing(0, 2),
  },
}));

export default useStyles;
